module.exports = __webpack_public_path__ + "img/logo.72b4d27d.png";